import { useDecodedToken } from './authorization.hook';

export function useIsAuthorized() {
  const token = useDecodedToken();
  const isAuthorized =
    !!token && (token.imPlatform !== 'X4EC' || !!token.resellerId);
  return isAuthorized;
}
